// extracted by mini-css-extract-plugin
export default {"formPopUpContainer":"formPopUp_formPopUpContainer__HwN30","closeIcon":"formPopUp_closeIcon__hUiZ4"};